import React from 'react';
import cn from 'classnames';
import type { NodeToRenderProps } from '@src/components/custom-nodes/types';

export const withSelection = (WrappedComponent: React.FC<NodeToRenderProps>) => {
  return function WithSelectionWrapper(props: NodeToRenderProps) {
    return (
      <WrappedComponent
        {...props}
        className={cn([ props?.className, {
          'border-2': props.selected,
          '!border-blue-400': props.selected,
        }])}
        >
        {props.children}
      </WrappedComponent>
    );
  };
}
